/* eslint-disable no-unused-vars */
import React, { useContext, useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import ArchiveIcon from '@mui/icons-material/Archive';
import { Button } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { DataGridPro } from '@mui/x-data-grid-pro';
import useCWPAminContext from '../context/useCWPAminContext';

function Table() {
  //
  const {
    activeTab,
    cwpData,
    loading,
    rowsSelected,
    setRowsSelected,
    handleDeleteAllSelected,
    handleRecoverAllSelected,
  } = useContext(useCWPAminContext);

  const [sortModel, setSortModel] = useState([
    {
      field: 'date_scheduled',
      sort: 'desc',
    },
  ]);

  const actionButton =
    activeTab === 0 || activeTab === 2
      ? [
          {
            field: 'action',
            flex: 1,
            headerName: 'Action',
            width: 200,
            renderCell: ({ row }) => (
              <div>
                {activeTab === 0 ? (
                  <Button
                    size='small'
                    variant='contained'
                    color='error'
                    onClick={(e) => handleDeleteAllSelected(row.appointment_id)}
                    startIcon={<DeleteIcon />}
                  >
                    Delete
                  </Button>
                ) : (
                  ''
                )}

                {activeTab === 2 ? (
                  <Button
                    size='small'
                    variant='contained'
                    color='success'
                    onClick={(e) => handleRecoverAllSelected(row.appointment_id)}
                    startIcon={<ArchiveIcon />}
                  >
                    Recover
                  </Button>
                ) : (
                  ''
                )}
              </div>
            ),
          },
        ]
      : [{ field: 'deleted_at', flex: 1, headerName: 'Date Deleted', width: 200 }];
  const columns = [
    { field: 'manager_name', flex: 1, headerName: 'Manager', width: 200 },
    { field: 'rep_name', flex: 1, headerName: 'MPR Name', width: 200 },
    { field: 'md_name', flex: 1, headerName: 'MD Name', width: 200 },
    { field: 'date_scheduled', flex: 1, headerName: 'Appointment Date', width: 200 },
    { field: 'status', flex: 1, headerName: 'Status', width: 200 },
    // ...actionButton,
  ];
  return (
    <Grid container spacing={2}>
      {activeTab === 0 || activeTab === 2 ? (
        <Grid xs={12} sm={12} md={12}>
          {rowsSelected.length > 0 ? (
            <div>
              {activeTab === 0 ? (
                <Button
                  size='small'
                  variant='contained'
                  color='error'
                  sx={{ float: 'right' }}
                  onClick={(e) => handleDeleteAllSelected(null, true)}
                  startIcon={<DeleteIcon />}
                >
                  Delete All Selected
                </Button>
              ) : (
                ''
              )}

              {activeTab === 2 ? (
                <Button
                  size='small'
                  variant='contained'
                  color='success'
                  sx={{ float: 'right' }}
                  onClick={(e) => handleRecoverAllSelected(null, true)}
                  startIcon={<ArchiveIcon />}
                >
                  Recover All Selected
                </Button>
              ) : (
                ''
              )}
            </div>
          ) : (
            ''
          )}
        </Grid>
      ) : (
        ''
      )}

      <Grid xs={12} sm={12} md={12}>
        <div className='table-container' style={{ height: '800px', marginLeft: '20px' }}>
          &nbsp;
          <DataGridPro
            rows={cwpData}
            columns={columns}
            loading={loading}
            sortModel={sortModel}
            checkboxSelection
            onSelectionModelChange={(ids) => {
              const selectedIDs = new Set(ids);
              const selectedRows = cwpData.filter((row) => selectedIDs.has(row.id));

              setRowsSelected(selectedRows);
            }}
            initialState={{
              ...cwpData.initialState,
              pagination: { paginationModel: { pageSize: 50 } },
            }}
            pageSizeOptions={[25, 50, 75, 100]}
            pagination
            onSortModelChange={(model) => setSortModel(model)}
          />
        </div>
      </Grid>
    </Grid>
  );
}

export default Table;
